import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

@Component({
    selector: 'ui-page-header',
    templateUrl: './ui-page-header.component.html',
    styleUrls: ['./ui-page-header.component.scss'],
    standalone: false
})
export class UiPageHeaderComponent {
    @Input() icon: string;
    @Input() doReturn: boolean = true;
    @Input() hasReturn: boolean = false;
    @Input() hasRefresh: boolean = false;
    @Input() subtitle: string;
    @Output() refreshed = new EventEmitter();
    @Output() returned = new EventEmitter();

    constructor(public location: Location, private router: Router) {
    }

    onRefreshClick() {
        this.refreshed.emit();
    }

    onReturnClick() {
        if (this.doReturn) {
            const returnFn = () => {
                const currentUrl = this.router.url;

                this.location.back();

                setTimeout(() => {
                    if (this.router.url === currentUrl) {
                        returnFn();
                    }
                }, 100);
            }

            returnFn();
        }

        this.returned.emit();
    }
}
